(function () {
  var SECTION_SELECTOR = '.oddit-section-benefits-card-carousel';
  var CARD_SELECTOR = '.oddit-section-benefits-card-carousel__card';
  var TOGGLE_SELECTOR = '.oddit-section-benefits-card-carousel__toggle';

  function initSection(section) {
    var track = section.querySelector('[data-carousel-track]');
    if (!track || track.dataset.odditCarouselReady === 'true') return;
    track.dataset.odditCarouselReady = 'true';

    var prevButtons = section.querySelectorAll('[data-carousel-prev]');
    var nextButtons = section.querySelectorAll('[data-carousel-next]');

    var originals = Array.prototype.slice.call(track.querySelectorAll(CARD_SELECTOR));
    var looping = originals.length > 1;

    if (looping) {
      originals.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-carousel-clone', '');
        clone.removeAttribute('aria-label');
        clone.classList.add('is-visible');
        clone.querySelectorAll('.oddit-reveal').forEach(function (el) {
          el.classList.add('is-visible');
        });
        track.appendChild(clone);
      });
    }

    function getSetWidth() {
      var firstClone = track.querySelector('[data-carousel-clone]');
      if (!firstClone || !originals.length) return 0;
      return firstClone.offsetLeft - originals[0].offsetLeft;
    }

    function jumpBy(delta) {
      // Instant, animation-free reposition (identical content → invisible).
      var prevBehavior = track.style.scrollBehavior;
      var prevSnap = track.style.scrollSnapType;
      track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';
      track.scrollLeft += delta;
      track.style.scrollBehavior = prevBehavior;
      track.style.scrollSnapType = prevSnap;
    }

    function normalize() {
      if (!looping) return;
      var setWidth = getSetWidth();
      if (!setWidth) return;
      if (track.scrollLeft >= setWidth) {
        jumpBy(-setWidth);
      }
    }

    // Re-normalize once scrolling settles (covers drag, touch and autoplay).
    var settleTimer = null;
    track.addEventListener('scroll', function () {
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(normalize, 120);
    }, { passive: true });

    function getCardWidth() {
      var card = track.querySelector(CARD_SELECTOR);
      if (!card) return 348;
      var rect = card.getBoundingClientRect();
      // include 1px overlap so we move card-to-card cleanly
      return rect.width - 1;
    }

    function goPrev() {
      if (looping && track.scrollLeft < getCardWidth()) {
        // Pre-jump one full set forward so there is always room to scroll back.
        jumpBy(getSetWidth());
      }
      track.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
    }

    function goNext() {
      normalize();
      track.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
    }

    prevButtons.forEach(function (btn) {
      btn.addEventListener('click', goPrev);
    });
    nextButtons.forEach(function (btn) {
      btn.addEventListener('click', goNext);
    });

    initDragScroll(track);
    initAutoplay(section, goNext);

    section.addEventListener('click', function (e) {
      var toggle = e.target.closest(TOGGLE_SELECTOR);
      if (!toggle) {
        var footer = e.target.closest('.oddit-section-benefits-card-carousel__card-footer');
        if (!footer || !section.contains(footer)) return;
        toggle = footer.querySelector(TOGGLE_SELECTOR);
      }
      if (!toggle || !section.contains(toggle)) return;
      var card = toggle.closest(CARD_SELECTOR);
      if (!card) return;
      var isExpanded = card.classList.toggle('oddit-section-benefits-card-carousel__card--expanded');
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      toggle.setAttribute('aria-label', isExpanded ? 'Collapse details' : 'Expand details');
    });
  }

  function initAutoplay(section, goNext) {
    if (section.dataset.autoplay !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var speed = (parseInt(section.dataset.autoplaySpeed, 10) || 5) * 1000;
    var timer = null;
    var inView = false;
    var paused = false;

    function update() {
      if (inView && !paused && !timer) {
        timer = setInterval(goNext, speed);
      } else if ((!inView || paused) && timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    section.addEventListener('pointerenter', function () { paused = true; update(); });
    section.addEventListener('pointerleave', function () { paused = false; update(); });
    section.addEventListener('focusin', function () { paused = true; update(); });
    section.addEventListener('focusout', function () { paused = false; update(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        update();
      }, { threshold: 0.25 }).observe(section);
    } else {
      inView = true;
      update();
    }
  }

  // Desktop drag-to-scroll (mouse only; touch keeps native scrolling).
  function initDragScroll(track) {
    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      // Only enter drag state once the pointer actually moves — otherwise a
      // plain click (e.g. on a card's accordion toggle) would be swallowed.
      if (!moved && Math.abs(dx) > 3) {
        moved = true;
        track.classList.add('is-dragging');
        track.style.scrollSnapType = 'none';
      }
      if (moved) {
        track.scrollLeft = startScroll - dx;
      }
    });

    function end() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      track.style.scrollSnapType = '';
    }

    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('pointerleave', end);

    // Swallow the click that follows a drag so it doesn't toggle a card / follow a link.
    track.addEventListener('click', function (e) {
      if (moved) {
        e.stopPropagation();
        e.preventDefault();
        moved = false;
      }
    }, true);

    // Prevent native image/link ghost-dragging.
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
